"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onKeyDown = exports.onInput = exports.focusedTypeAheadIndex = exports.focusedTypeAheadId = void 0;
const vue_1 = require("vue");
const fetch_jsonp_1 = __importDefault(require("fetch-jsonp"));
const core_1 = require("@vueuse/core");
const dataLayer_1 = require("@/SearchApp/services/dataLayer");
const ocm_object_1 = require("@ocm/services/ocm-object");
const use_department_1 = __importDefault(require("./use-department"));
const use_most_suggested_request_1 = __importDefault(require("./use-most-suggested-request"));
const use_findings_1 = __importStar(require("./use-findings"));
const epoq_request_settings_1 = require("@/SearchApp/services/epoq-request-settings");
const services_epoq_1 = require("@ocm/services/services.epoq");
const services_constants_1 = require("@ocm/services/services.constants");
const ocm_mercurius_messenger_1 = __importDefault(require("ocm_mercurius_messenger"));
exports.focusedTypeAheadId = (0, vue_1.ref)();
exports.focusedTypeAheadIndex = (0, vue_1.ref)(-1);
const searchPagePath = `${ocm_object_1.contextPath}/${ocm_object_1.language === "de" ? "suche" : "search"}/`;
const searchCategoryHashLabel = ocm_object_1.language === "de" ? "Kategorie" : "Category";
const requestFinished = (0, vue_1.ref)(true);
const isLoading = (0, vue_1.ref)(false);
const _setLoading = () => {
    if (!requestFinished.value)
        isLoading.value = true;
};
const _debounceLoading = (0, core_1.useDebounceFn)(_setLoading, 150);
const _setRequestFinished = () => {
    requestFinished.value = true;
    isLoading.value = false;
};
const userInput = (0, vue_1.ref)("");
const userInputMaxlength = 150;
// android fix for not updated v-model value on input TUB-16479
const setUserInput = (newInput) => {
    userInput.value = newInput;
};
let searchQuery = "";
const isSearchMostSuggested = (0, vue_1.computed)(() => userInput.value.length < 3);
const isSearchVisible = (0, vue_1.ref)(false);
const { setFindings } = (0, use_findings_1.default)();
const _epoqRequest = async (requestUrl) => {
    const requestParams = (0, epoq_request_settings_1.getEpoqRequestParams)(searchQuery);
    const jsonpUrl = new URL(`${requestUrl}?${new URLSearchParams(requestParams)}`).toString();
    requestFinished.value = false;
    _debounceLoading();
    try {
        const response = await (0, fetch_jsonp_1.default)(jsonpUrl);
        if (!response.ok)
            throw new Error("Epoq Search request failed");
        const { result } = await response.json();
        setFindings(result);
    }
    catch (err) {
        console.error(err);
    }
    finally {
        _setRequestFinished();
    }
};
let useFallback = false;
const setUpRequest = async () => {
    try {
        await Promise.race([_epoqRequest(useFallback ? services_epoq_1.EPOQ_SEARCH_FALLBACK_URL : services_epoq_1.EPOQ_SEARCH_URL), (0, services_epoq_1.epoqRequestTimeout)()]);
    }
    catch (err) {
        console.error(err);
        if (useFallback)
            return;
        useFallback = true;
        // retry with fallback URL
        setUpRequest();
        // reset to default URL after 5 minutes
        setTimeout(() => {
            useFallback = false;
        }, services_epoq_1.EPOQ_SEARCH_FALLBACK_TIMEOUT);
    }
};
const _debounceRequest = (0, core_1.useDebounceFn)(setUpRequest, 200);
const inputEl = (0, vue_1.ref)(null);
const triggerTypeAhead = () => {
    if (isSearchMostSuggested.value)
        return;
    searchQuery = userInput.value;
    _debounceRequest();
};
const focusSearch = () => {
    var _a;
    (_a = inputEl === null || inputEl === void 0 ? void 0 : inputEl.value) === null || _a === void 0 ? void 0 : _a.focus();
};
const setInputElementRef = (ref) => {
    inputEl.value = ref;
};
const resetSearch = () => {
    var _a;
    userInput.value = "";
    (_a = inputEl === null || inputEl === void 0 ? void 0 : inputEl.value) === null || _a === void 0 ? void 0 : _a.blur();
    ocm_mercurius_messenger_1.default.publish(services_constants_1.messengerPublicationTypes.CLOSE_SEARCH);
};
const openSearch = () => {
    if (isSearchVisible.value) {
        focusSearch();
        return;
    }
    (0, use_most_suggested_request_1.default)().loadSuggestions();
    isSearchVisible.value = true;
    (0, vue_1.nextTick)(() => {
        focusSearch();
    });
    triggerTypeAhead();
};
const closeSearch = () => {
    var _a;
    if (!isSearchVisible.value)
        return;
    isSearchVisible.value = false;
    (_a = inputEl === null || inputEl === void 0 ? void 0 : inputEl.value) === null || _a === void 0 ? void 0 : _a.blur();
};
const deleteSearch = () => {
    userInput.value = "";
    focusSearch();
    triggerTypeAhead();
};
const { departmentCapitalized, department } = (0, use_department_1.default)();
const _navigateToShopSearchResult = (searchEncoded) => {
    const url = `${searchPagePath}?s=${searchEncoded}&department=${department.value}#/${searchCategoryHashLabel}/${departmentCapitalized.value}`;
    if (window.ocmOrchestrator) {
        window.ocmOrchestrator.spaNavigateUrl(url);
        ocm_mercurius_messenger_1.default.publish(services_constants_1.messengerPublicationTypes.SEARCH_SUBMITTED);
        resetSearch();
    }
    else {
        window.location.assign(url);
    }
};
var triggerType;
(function (triggerType) {
    triggerType["click"] = "textsearch";
    triggerType["keyboard"] = "textsearch";
    triggerType["voice"] = "voicesearch";
})(triggerType || (triggerType = {}));
const triggerSearch = (trigger = "keyboard") => {
    const navigated = navigateToSelectedTypeAheadItem();
    if (navigated || userInput.value.length < 1)
        return;
    (0, dataLayer_1.tr_searchEvent)({ searchterm: userInput.value, type: triggerType[trigger] });
    const searchEncoded = encodeURIComponent(userInput.value.substring(0, userInputMaxlength).trim());
    _navigateToShopSearchResult(searchEncoded);
    if (window.EpoqNS) {
        console.log("%c%s", "color:#fff;background-color:#35495e;", "search: EpoqNS.epoqForeignInit");
        const stateUrl = window.location.href;
        window.EpoqNS.epoqForeignInit({ stateUrl });
    }
};
function navigateToSelectedTypeAheadItem() {
    var _a;
    if (exports.focusedTypeAheadIndex.value > -1 && exports.focusedTypeAheadId.value) {
        const linkDestination = (_a = document.getElementById(exports.focusedTypeAheadId.value)) === null || _a === void 0 ? void 0 : _a.getAttribute("href");
        if (linkDestination) {
            window.location.assign(linkDestination);
            return true;
        }
    }
    return false;
}
const onInput = (target) => {
    setUserInput(target.value);
    exports.focusedTypeAheadIndex.value = -1;
    exports.focusedTypeAheadId.value = undefined;
    triggerTypeAhead();
};
exports.onInput = onInput;
const onKeyDown = (event) => {
    switch (event.key) {
        case "ArrowUp":
            handleArrowUpAndDown(-1);
            event.preventDefault(); // prevent scrolling when focus is on submit or microphone button and from moving cursor
            break;
        case "ArrowDown":
            handleArrowUpAndDown(1);
            event.preventDefault();
            break;
    }
};
exports.onKeyDown = onKeyDown;
const { mostSuggestedItems } = (0, use_most_suggested_request_1.default)();
const nrOfDisplayedTypeAheadItems = (0, vue_1.computed)(() => isSearchMostSuggested.value ? mostSuggestedItems.value.mostSearchItems.length : use_findings_1.findingsSize.value);
const handleArrowUpAndDown = (movementIndex) => {
    const totalItems = nrOfDisplayedTypeAheadItems.value;
    exports.focusedTypeAheadIndex.value = (exports.focusedTypeAheadIndex.value + movementIndex + totalItems) % totalItems;
};
function useSearch() {
    return {
        isLoading,
        requestFinished,
        setUpRequest,
        userInput,
        userInputMaxlength,
        setInputElementRef,
        isSearchVisible,
        isSearchMostSuggested,
        openSearch,
        closeSearch,
        focusSearch,
        deleteSearch,
        triggerSearch,
        resetSearch,
        onKeyDown: exports.onKeyDown,
        onInput: exports.onInput,
        nrOfDisplayedTypeAheadItems,
        searchPagePath,
        searchCategoryHashLabel,
    };
}
exports.default = useSearch;
